var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03728 1.89974C7.1836 1.68745 7.19439 1.40981 7.06498 1.18681C6.93557 0.9638 6.68917 0.835409 6.43225 0.857111C3.01583 1.1457 0.333496 4.0092 0.333496 7.49989C0.333496 11.1818 3.31826 14.1666 7.00016 14.1666C10.4909 14.1666 13.3543 11.4842 13.6429 8.0678C13.6646 7.81088 13.5363 7.56448 13.3132 7.43507C13.0902 7.30566 12.8126 7.31645 12.6003 7.46277C11.9562 7.9067 11.1762 8.16656 10.3335 8.16656C8.12436 8.16656 6.3335 6.37569 6.3335 4.16656C6.3335 3.32385 6.59335 2.54383 7.03728 1.89974Z",
    fill: "#03071285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepActive);
export default __webpack_public_path__ + "static/media/sleep-active.b80af65604b709839d3c8578e268224f.svg";
export { ForwardRef as ReactComponent };